import React, { useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getSinglePolicyDetails } from "../../../redux/slice/policy/policySlice";
import {
  exportXlsxData,
} from "../../../utils/helpers/functions";
import PaginationLinks from "../../pagination/PaginationLinks";
import excel from "../../../assets/images/img-icons/excel.png";
import pdf from "../../../assets/images/img-icons/pdf.png";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import ModalContainer from "../../modals/ModalContainer";
import PayPremium from "../../modals/policy/PayPremium";

const Transactions = ({ customerTransactions, view }) => {
  const [editing, setEditing] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState(null);

  const { state } = useLocation();
  const dispatch = useDispatch();
  const CCPdfRef = useRef();

  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => CCPdfRef.current,
    documentTitle: "Customer Transactions",
  });

  const fetchTransactionHandler = async (pageNum) => {
    dispatch(
      getSinglePolicyDetails({
        customer_id: state?.customerId,
        policy_number: state?.policyAppNumber,
        pageNumber: pageNum,
      })
    );
  };

  console.log(customerTransactions);

  return (
    <div className='row mb-3'>
      <>
        <div className='d-flex justify-content-end align-items-center'>
          <div className=' d-flex align-items-center border '>
            <span
              className='bg-info me-2 text-white'
              style={{ padding: "3px" }}
            >
              Export to
            </span>

            <span
              href='#'
              id='btnExport'
              className='me-1 cursor-p'
              title='Export to Pdf'
              onClick={generatePDF}
            >
              <img src={pdf} alt='export-pdf' style={{ height: "25px" }} />
            </span>
            <CSVLink
              data={exportXlsxData(
                customerTransactions?.data,
                "All User Activities"
              )}
              style={{ fontWeight: "bolder", cursor: "pointer" }}
              filename='Corperate customers'
            >
              <span
                href='#'
                id='btnExport'
                className='mr-1'
                title='Export to Excel'
              >
                <img
                  src={excel}
                  alt='export-excel'
                  style={{ height: "25px", marginRight: "5px" }}
                />
              </span>
            </CSVLink>
          </div>
        </div>
        <div className='table-responsive'>
          <table
            className='table table-centered table-striped nowrap w-100 no-footer'
            ref={CCPdfRef}
          >
            <thead>
              <tr>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "150.8px" }}
                  aria-label='Email: activate to sort column ascending'
                >
                  Transaction Id
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "120.8px" }}
                  aria-label='Customer: activate to sort column ascending'
                >
                  Payment Date
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "124.8px" }}
                  aria-label='Phone: activate to sort column ascending'
                >
                  Effective Date
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "114.8px" }}
                  aria-label='Phone: activate to sort column ascending'
                >
                  Debit
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "116.8px" }}
                  aria-label='Location: activate to sort column ascending'
                >
                  Credit
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "120.8px" }}
                  aria-label='Status: activate to sort column ascending'
                >
                  Balance
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "110.8px" }}
                  aria-label='Status: activate to sort column ascending'
                >
                  Status
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "120.8px" }}
                  aria-label='Status: activate to sort column ascending'
                >
                  Description
                </th>
                {view ? <th style={{ width: "85.8px" }}>Action</th> : null}
              </tr>
            </thead>
            {customerTransactions?.data?.length ? (
              <tbody>
                {customerTransactions?.data?.map((item, i) => {
                  let show = customerTransactions?.data?.some(
                    (obj) => obj.complete_payment === "1"
                  );
                  if (show) {
                    if (item?.complete_payment === "1") {
                      show = true;
                    } else {
                      show = false;
                    }
                  } else {
                    show = true;
                  }

                  return (
                    <tr key={i}>
                      <td className='text-dark'>{item?.transaction_Id}</td>
                      <td className='table-user'>
                        <span className='text-body fw-semibold'>
                          {item?.payment_date}
                        </span>
                      </td>
                      <td className='table-user'>
                        <span className='text-body fw-semibold'>
                          {moment(item?.created_at).format("ll")}
                        </span>
                      </td>
                      <td>
                        {" "}
                        <span className='text-danger fw-bolder'>
                          {item?.debit ? `-${item?.debit}` : null}
                        </span>
                      </td>
                      <td>
                        {" "}
                        <span className='text-success fw-bolder'>
                          {item?.credit ? `+${item?.credit}` : null}
                        </span>
                      </td>
                      <td>{item?.balance}</td>
                      <td className='text-capitalize'>
                        {item?.transaction_type}
                      </td>
                      <td>{item?.desc?.trim(0, 30)}</td>
                      {view ? (
                        <td className='text-body'>
                          <span>
                            {console.log(item)}
                            <i
                              className='mdi mdi-eye text-primary fs-4 mx-2'
                              data-bs-toggle='modal'
                              data-bs-target='#pay_premium'
                              onClick={() => {
                                setEditing(true);
                                setTransactionDetails({
                                  transaction_id: item?.transaction_Id,
                                  payment_date: item?.payment_date,
                                  desc: item?.desc,
                                  part_premium: item?.credit,
                                  transaction_type: item?.transaction_type,
                                  complete_payment: show,
                                  customer_id: item?.customer_id,                                 
                                  policy_app_no: item?.policy_application_no,
                                });
                              }}
                            ></i>
                          </span>
                        </td>
                      ) : null}
                    </tr>
                  );
                })}
              </tbody>
            ) : null}
          </table>
          {customerTransactions?.data?.length < 1 ? (
            <h5 className='alert alert-info'>No result found!</h5>
          ) : null}
        </div>

        {customerTransactions?.data?.length > 0 && (
          <div className='row mt-2'>
            <div className='col-sm-12 col-md-6'>
              <div
                className='dataTables_info table-pages'
                id='products-datatable_info'
                role='status'
                aria-live='polite'
              >
                Showing transactions {customerTransactions?.from} to{" "}
                {customerTransactions?.to} of {customerTransactions?.total}
              </div>
            </div>
            <div className='col-sm-12 col-md-6'>
              <PaginationLinks
                paginationData={customerTransactions}
                getNextPage={fetchTransactionHandler}
              />
            </div>
          </div>
        )}
      </>
      <ModalContainer
        modal_id='pay_premium'
        modal_width='modal-md'
        bradius='rounded-2'
      >
        <PayPremium
          editing={editing}
          setEditing={setEditing}
          transactionDetails={transactionDetails}
          setTransactionDetails={setTransactionDetails}
        />
      </ModalContainer>
    </div>
  );
};

export default Transactions;
